import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon PrintIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const PrintIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 18 17">
      <path d="M16,3h-2V2c0-1.1-0.9-2-2-2H6C4.9,0,4,0.9,4,2v1H2C0.9,3,0,3.9,0,5v7c0,1.1,0.9,2,2,2h1v2.2C3,16.7,3.3,17,3.8,17h10.5 c0.4,0,0.7-0.3,0.8-0.7l0,0V14h1c1.1,0,2-0.9,2-2V5C18,3.9,17.1,3,16,3L16,3z M5.5,2c0-0.3,0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5 v1h-7V2z M13.5,15.5h-9v-5h9V15.5z M16.5,12c0,0.3-0.2,0.5-0.5,0.5h-1V9.8C15,9.3,14.7,9,14.3,9l0,0H3.7C3.3,9,3,9.3,3,9.7l0,0v2.8 H2c-0.3,0-0.5-0.2-0.5-0.5V5c0-0.3,0.2-0.5,0.5-0.5h14c0.3,0,0.5,0.2,0.5,0.5V12z M10.8,13H7.2c-0.3,0-0.5-0.2-0.5-0.5 S6.9,12,7.2,12h3.6c0.3,0,0.5,0.2,0.5,0.5S11.1,13,10.8,13z M10.8,14.2H7.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.6 c0.3,0,0.5,0.2,0.5,0.5C11.3,14,11.1,14.2,10.8,14.2L10.8,14.2L10.8,14.2z M3.5,6C3.8,6,4,6.2,4,6.5S3.8,7,3.5,7S3,6.8,3,6.5 S3.2,6,3.5,6z M5.5,6C5.8,6,6,6.2,6,6.5S5.8,7,5.5,7S5,6.8,5,6.5S5.2,6,5.5,6z" />
    </Icon>
  )
}
export default PrintIcon
